import React from 'react';
import css from './single-class.scss';
import {
    GROUP_NAME,
    ASSIGNED_QUESTS,
    COMPLETED_QUESTS,
    COMPLETED_QUESTS_SUMMARY,
    STANDARDS_COMPLETED,
    STANDARDS_IN_PROGRESS,
    STUDENT_FULL_NAME
} from '../skill-quests-mastery-constants';

import TableHeader from '../../../components/table-header/table-header';
import { getTranslationKey } from '../../../helpers/locale-helpers';
import { SKILL_QUESTS_MASTERY } from '../../../components/report-filters/filter-constants';

const SINGLE_CLASS_SKILL_QUESTS_MASTERY_TABLE_CONFIG = {
    cols: [
        {
            id: GROUP_NAME.id,
            name: GROUP_NAME.name,
            sort: { sortAs: 'string' },
            truncate: true,
            onClick: () => null, // this is set in the SingleClass component
            classes: null
        },
        {
            id: COMPLETED_QUESTS_SUMMARY.id,
            name: COMPLETED_QUESTS_SUMMARY.name,
            classes: css['completed-quests']
        },
        {
            id: STANDARDS_IN_PROGRESS.id,
            name: ''
        },
        {
            id: STANDARDS_COMPLETED.id,
            name: ''
        },
        {
            id: ASSIGNED_QUESTS.id,
            name: ''
        },
        {
            id: COMPLETED_QUESTS.id,
            name: ''
        }
    ],
    colGroups: [
        [
            {
                colIds: [GROUP_NAME.id, COMPLETED_QUESTS_SUMMARY.id],
                classes: css['dark-header'],
                name: GROUP_NAME.name,
                truncate: true,
                headerTransform: () => (
                    <TableHeader
                        title={getTranslationKey(SKILL_QUESTS_MASTERY)}
                        translate
                    />
                )
            },
            {
                name: STANDARDS_IN_PROGRESS.name,
                colIds: [STANDARDS_IN_PROGRESS.id],
                classes: css['light-header']
            },
            {
                name: STANDARDS_COMPLETED.name,
                colIds: [STANDARDS_COMPLETED.id],
                classes: css['light-header']
            },
            {
                name: ASSIGNED_QUESTS.name,
                colIds: [ASSIGNED_QUESTS.id],
                classes: css['light-header']
            },
            {
                name: COMPLETED_QUESTS.name,
                colIds: [COMPLETED_QUESTS.id],
                classes: css['light-header']
            }
        ]
    ],
    nestedData: {
        id: 'students',
        cols: [
            {
                id: STUDENT_FULL_NAME.id,
                classes: css['student-full-name-wrapper'],
                onClick: () => null
            },
            {
                id: COMPLETED_QUESTS_SUMMARY.id
            },
            {
                id: STANDARDS_IN_PROGRESS.id,
                classes: css['basic-cell']
            },
            {
                id: STANDARDS_COMPLETED.id,
                classes: css['basic-cell']
            },
            {
                id: ASSIGNED_QUESTS.id,
                classes: css['basic-cell']
            },
            {
                id: COMPLETED_QUESTS.id,
                classes: css['basic-cell']
            }
        ]
    },
    emptyDataMessage: 'No Skill Quests Mastery results found'
};

export default SINGLE_CLASS_SKILL_QUESTS_MASTERY_TABLE_CONFIG;



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/single-class/single-class-constants.js